import { render, staticRenderFns } from "./_casinoSection.vue?vue&type=template&id=2a825bce&scoped=true&lang=pug&"
import script from "./_casinoSection.vue?vue&type=script&lang=js&"
export * from "./_casinoSection.vue?vue&type=script&lang=js&"
import style0 from "./_casinoSection.vue?vue&type=style&index=0&id=2a825bce&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a825bce",
  null
  
)

export default component.exports